import { NgModule } from '@angular/core';
import { SStatsCardAbsenteeismComponent } from './s-stats-card-absenteeism.component';
import { CommonModule } from '@angular/common';
import { SStatsCardAbsenteeismService } from './s-stats-card-absenteeism.service';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { LoadingStateModule, StatsCardModule } from '@seniorsistemas/angular-components';

@NgModule({
    imports: [
        CommonModule,
        StatsCardModule,
        HttpClientModule,
        SharedModule,
        LoadingStateModule
    ],
    declarations: [SStatsCardAbsenteeismComponent],
    providers: [SStatsCardAbsenteeismService],
    exports: [SStatsCardAbsenteeismComponent]
})
export class SStatsCardAbsenteeismModule { }
